import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";

export default function NotFoundPage() {
  return (
    <Layout>
      <section className="max-w-4xl mx-auto px-6 md:px-10 py-32 text-center" data-testid="not-found">
        <p className="font-mono text-[10px] uppercase tracking-wide-3 text-ink-500">
          Error 404 · Reference not found
        </p>
        <h1 className="mt-6 font-heading text-4xl md:text-6xl font-medium text-ink-900 tracking-[-0.02em]">
          This entry is not in the index.
        </h1>
        <p className="mt-6 text-base text-ink-600 max-w-xl mx-auto leading-relaxed">
          The industry or problem you requested has not been documented yet. Return to the directory to browse the verticals currently in the library.
        </p>
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2 px-7 py-3 bg-vermilion text-bone hover:bg-ink-900 hover:text-bone font-mono text-[11px] uppercase tracking-wide-2 transition-colors"
          data-testid="not-found-home-link"
        >
          Return to directory
        </Link>
      </section>
    </Layout>
  );
}
